exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YGSLI-Cl7Hv8au-7OwzKE{display:inline-block;margin-right:10px;height:80px;width:80px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"HighlightedPhoto": "_3YGSLI-Cl7Hv8au-7OwzKE"
};